module.exports = __webpack_public_path__ + "img/U1F47D.22a76627.png";